module.exports = __webpack_public_path__ + "img/mamoncillo-350x184.509d1ea2.jpg";